"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUIState = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const utils_1 = require("../components/UIState/utils");
function useUIState(props, { name, state, persist = false }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const stateName = (0, react_1.useMemo)(() => (typeof name === 'function' ? name(props) : name), [props]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initialState = (0, react_1.useMemo)(() => (typeof state === 'function' ? state(props) : state), [props]);
    const prevStateName = (0, react_use_1.usePrevious)(stateName);
    // selector for this slice of UI state
    const reduxUiState = (0, react_redux_1.useSelector)((uiState) => { var _a; return (_a = uiState[utils_1.UISTATE_REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.get(stateName); });
    // dispatchers (matching your HOC version)
    const add = (0, react_1.useCallback)((payload) => dispatch({
        type: (0, utils_1.generateType)(utils_1.types.add, stateName),
        payload: {
            name: stateName,
            state: payload,
        },
    }), [dispatch, stateName]);
    // const remove = useCallback(() => dispatch({
    //   type: generateType(types.delete, stateName),
    //   payload: { name: stateName },
    // }), [dispatch, stateName]);
    const reset = (0, react_1.useCallback)((payload) => dispatch({
        type: (0, utils_1.generateType)(utils_1.types.reset, stateName),
        payload: {
            name: stateName,
            state: payload,
        },
    }), [dispatch, stateName]);
    const set = (0, react_1.useCallback)((payload) => dispatch({
        type: (0, utils_1.generateType)(utils_1.types.set, stateName),
        payload: {
            name: stateName,
            state: payload,
        },
    }), [dispatch, stateName]);
    // Memoized setters (preserves your fnCache logic)
    const resetUiState = (0, react_1.useMemo)(() => (0, utils_1.generateResetUiState)(reset, stateName, () => initialState), [reset, stateName, initialState]);
    const setUiState = (0, react_1.useMemo)(() => (0, utils_1.generateSetUiState)(set, stateName), [set, stateName]);
    (0, react_use_1.useMount)(() => {
        if (!persist || !reduxUiState) {
            add(initialState);
        }
    });
    (0, react_1.useEffect)(() => {
        if (prevStateName && prevStateName !== stateName) {
            // Add new state if missing
            if (!reduxUiState) {
                add(initialState);
            }
            // Delete old state if not persistent
            if (!persist) {
                dispatch({
                    type: (0, utils_1.generateType)(utils_1.types.delete, prevStateName),
                    payload: { name: prevStateName },
                });
            }
        }
    }, [stateName, prevStateName, add, persist, initialState, reduxUiState, dispatch]);
    return {
        uiState: reduxUiState !== null && reduxUiState !== void 0 ? reduxUiState : initialState,
        setUiState,
        setUIState: setUiState,
        resetUiState,
        resetUIState: resetUiState,
        uiStateName: stateName,
    };
}
exports.useUIState = useUIState;
